import apiClient from '../apiClient';

export interface EntityViewLogRequest {
    entity_type: 'company' | 'person' | 'report' | 'risk_profile';
    entity_id: string;
    entity_label?: string;
}

export interface EntityViewLogResponse {
    id: string;
    entity_type: 'company' | 'person' | 'report' | 'risk_profile';
    entity_id: string;
    entity_label?: string;
    inserted_at: string;
}

export const logEntityView = async (data: EntityViewLogRequest) => {
    return await apiClient.post('/logging/view', data);
};

export const getRecentViews = async (entity_type?: string, limit: number = 10) => {
    const params: any = { limit };
    if (entity_type) params.entity_type = entity_type;
    return await apiClient.get<EntityViewLogResponse[]>('/logging/recent', { params });
};
